module.exports = __webpack_public_path__ + "static/media/HIL-Landscape.c10789c9.png";